<template>
  <div
    class="my-5 w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
  >
    <BackSvg @click="$router.go(-1)" />
  </div>
  <div
    class="h-48 bg-white border border-neutral-200 rounded-lg shadow-[0_10px_50px_rgba(0,0,0,0.1)] px-4 sm:px-6"
  >
    <div class="h-full flex items-center justify-between gap-4">
      <!-- Text -->
      <div class="flex-1 min-w-0">
        <h1 class="text-lg sm:text-xl text-orange-500 font-semibold mb-2">
          {{ translations.title }}
        </h1>

        <p class="text-sm text-neutral-600 leading-relaxed">
          {{ translations.description }}
        </p>
      </div>

      <!-- Image -->
      <div class="flex-shrink-0">
        <img
          :src="require('@/assets/images/customer-service.png')"
          alt="Customer Service"
          class="w-32 sm:w-36 md:w-40 h-auto object-contain"
        />
      </div>
    </div>
  </div>
  <div class="my-5 space-y-3">
    <h3 class="pt-2 pb-0 font-semibold text-lg text-orange-500">
      {{ translations.itemCategoriesTitle.itemOne }}
    </h3>
    <a
      href="https://iwc.com.ph/services/providers"
      target="_blank"
      rel="noopener noreferrer"
      class="text-xs text-zinc-600 hover:text-orange-500 transition-colors"
    >
      {{ translations.providerLink }}
    </a>
    <div
      v-for="(item, index) in availmentProcess"
      :key="index"
      class="bg-white border rounded-xl overflow-hidden transition-all duration-300"
      :class="
        activeIndex === index
          ? 'border-orange-300 shadow-md'
          : 'border-neutral-200 hover:border-orange-200'
      "
    >
      <button
        @click="toggleAccordion(index)"
        class="w-full flex items-center justify-between px-4 py-4 text-left group"
      >
        <span
          class="font-medium text-sm transition-colors"
          :class="
            activeIndex === index
              ? 'text-orange-500'
              : 'text-neutral-700 group-hover:text-orange-500'
          "
        >
          {{ item.question }}
        </span>

        <div
          class="flex items-center justify-center w-8 h-8 rounded-full transition-all duration-300"
          :class="
            activeIndex === index
              ? 'bg-orange-100 text-orange-500'
              : 'bg-neutral-100 text-neutral-500'
          "
        >
          <svg
            class="w-4 h-4 transition-transform duration-300"
            :class="{ 'rotate-180': activeIndex === index }"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </button>

      <transition
        enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-200 ease-in"
      >
        <div v-show="activeIndex === index" class="border-t border-neutral-100">
          <div
            class="px-4 py-4 text-sm text-neutral-600 leading-relaxed"
            v-html="item.answer"
          ></div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { ref, computed } from "vue";
import BackSvg from "@/components/svgs/BackSvg.vue";
import { useLanguage } from "@/utils/composables/useLanguage";
export default {
  components: { BackSvg },

  setup() {
    const { selectedLanguage } = useLanguage();
    const activeIndex = ref(null);
    const translations = computed(
      () =>
        ({
          en: {
            title: "Welcome to the Information Center",
            description:
              "Access important information, member guides, and FAQs about IMS Wellth Care services.",
            faqTitle: "Frequently Asked Questions",
            itemCategoriesTitle: {
              itemOne: "Availment Process",
              itemTwo: "Provider Directories",
              itemThree: "Frequently Asked Questions",
            },
            providerLink: "Click here to browse accredited hospitals & clinics",
          },
          ph: {
            title: "Maligayang Pagdating sa Information Center",
            description:
              "Makakuha ng mahahalagang impormasyon, gabay para sa mga miyembro, at mga madalas itanong tungkol sa mga serbisyo ng IMS Wellth Care.",
            faqTitle: "Mga Madalas Itanong",
            itemCategoriesTitle: {
              itemOne: "Proseso ng Paggamit ng Benepisyo",
              itemTwo: "Listahan ng mga Accredited Provider",
              itemThree: "Mga Madalas Itanong",
            },
            providerLink:
              "Pindutin dito upang makita ang listahan ng mga accredited na ospital at klinika.",
          },
        }[selectedLanguage.value])
    );

    const availmentProcessEnglish = [
      {
        question: "Out-patient",
        answer: `
      <div class="space-y-4">

        <div>
          <h4 class="font-semibold text-orange-500 mb-2">
            For Accredited Hospitals / Clinics
          </h4>

          <ul class="list-disc pl-5 space-y-2">
            <li>Proceed to the OPD HMO or Industrial Department.</li>
            <li>Present your IWC Membership Card and any valid government-issued ID for verification.</li>
            <li>Hospital or clinic staff will contact the IWC Customer Service Department to verify your eligibility and available benefits.</li>
            <li>Once eligibility has been confirmed, the necessary approval will be issued.</li>
            <li>Proceed with your consultation or medical service.</li>
            <li>
              <strong>Excess charges beyond the approved benefit limit shall be shouldered by the member.</strong>
            </li>
          </ul>
        </div>

      </div>
    `,
      },
      {
        question: "In-patient",
        answer: `
    <div>
      <h4 class="font-semibold text-orange-500 mb-2">
        In-Patient Availment Process
      </h4>

      <ul class="list-disc pl-5 space-y-2">
        <li>
          Proceed to the HMO or Admitting Department of the accredited hospital.
        </li>
        <li>
          Present your IWC Membership Card and any valid government-issued ID for verification.
        </li>
        <li>
          Hospital staff will contact the IWC Customer Service Department to verify your eligibility and available benefits.
        </li>
        <li>
          Once eligibility has been confirmed, the corresponding
          <strong>Letter of Eligibility (LOE)</strong> will be issued.
        </li>
      </ul>
    </div>
  `,
      },
      {
        question: "Annual Physical Examination (APE)",
        answer: `
    <div class="space-y-4">

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Annual Physical Examination (APE) Guidelines
        </h4>

        <ol class="list-decimal pl-5 space-y-3">
          <li>
            All requests for Annual Physical Examinations (APE) must be endorsed by the Marketing Agent and communicated to the IWC Customer Service Department (CSD) prior to availment.
          </li>

          <li>
            <strong>Submission of APE Requests</strong>
            <p class="mt-2 mb-1">
              Requests for APE must be submitted within the following time frame prior to the preferred schedule:
            </p>

            <div class="ml-4">
              <p class="font-medium">Walk-in APE:</p>
              <ul class="list-disc pl-5 mt-1 space-y-1">
                <li>2 days for individuals (1–4 participants)</li>
                <li>5 days for small groups (5–10 participants)</li>
                <li>2 weeks for big groups (11 or more participants)</li>
              </ul>

              <p class="font-medium mt-3">Mobile / On-Site APE:</p>
              <ul class="list-disc pl-5 mt-1">
                <li>Requests must be submitted at least 3 weeks in advance.</li>
              </ul>
            </div>
          </li>

          <li>
            <strong>Member Attendance</strong>

            <ul class="list-disc pl-5 mt-2 space-y-1">
              <li>
                Members who have been issued pre-approval codes are expected to attend their scheduled APE.
              </li>
              <li>
                Members who are unable to attend must provide IWC with at least 24 hours' notice before the scheduled date.
              </li>
              <li>
                Failure to provide notice will result in the member being tagged as <strong>"Already Availed"</strong> and the APE benefit for the year will be forfeited.
              </li>
              <li>
                The Marketing Agent may still extend APE benefits to the member at their own expense.
              </li>
            </ul>
          </li>

          <li>
            Requests for Mobile / On-Site APE will only be accommodated for groups with
            <strong>100 or more participants.</strong>
          </li>

          <li>
            IWC-CSD will review and verify all endorsed members.
          </li>

          <li>
            Once verified, only eligible members will be endorsed to the clinic for APE availment.
          </li>
        </ol>
      </div>

      <div class="bg-orange-50 border border-orange-100 rounded-lg p-4">
        <h4 class="font-semibold text-orange-500 mb-2">
          Coverage and Assistance
        </h4>

        <p>
        APE assistance of up to benefit shall be provided, subject to proper coordination with IWC's Customer Service Department for clinic endorsement.
        </p>
      </div>

    </div>
  `,
      },
      {
        question: "Insurance",
        answer: `
    <div class="space-y-4">

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Insurance Claims Process
        </h4>

        <ol class="list-decimal pl-5 space-y-2">
          <li>
            Claims must be filed within <strong>one (1) year</strong> from the date of death. For late filings, a <strong>Letter of Late Filing</strong> must be submitted.
          </li>

          <li>
            Submit the original notarized documents or e-mail scanned notarized copies to:
            <div class="mt-2 ml-2">
              <p><strong>policy.department@iwc.com.ph</strong></p>
              <p><strong>iwc.policydepartment@gmail.com</strong></p>
            </div>
          </li>

          <li>
            Upon receipt, documents will be reviewed and forwarded to First Life Insurance for initial evaluation.
          </li>

          <li>
            The claimant will be notified whether the submitted documents are complete or if additional requirements are needed.
          </li>

          <li>
            Once approved, claimants who initially submitted scanned copies must submit all original notarized documents.
          </li>

          <li>
            Processing time is approximately <strong>forty-five (45) days</strong> from receipt of complete requirements.
          </li>
        </ol>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Required Documents
        </h4>

        <ul class="list-disc pl-5 space-y-2">
          <li>Death Certificate (Certified True Copy)</li>
          <li>Life Insured's Proof of Age (PSA Birth Certificate, Certified True Copy Birth Certificate, or Baptismal Certificate)</li>
          <li>Marriage Certificate (PSA), if married</li>
          <li>Birth Certificate or Baptismal Certificate of the Primary Beneficiary</li>
          <li>Certificate of Attending Physician's Statement, duly completed, signed, and notarized</li>
          <li>Certificate of Claimant/Beneficiary, duly completed and notarized</li>
          <li>Certificate of Authorization completed by the Primary Beneficiary</li>
        </ul>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Additional Requirements for Accidental Death
        </h4>

        <ul class="list-disc pl-5 space-y-2">
          <li>Traffic Accident Report</li>
          <li>Final Police Investigation Report</li>
        </ul>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Additional Requirements for Group Policy Holders
        </h4>

        <ul class="list-disc pl-5 space-y-2">
          <li>Death Claim Form (Employer)</li>
          <li>Certificate of Outstanding Balance (for GCLI or MRI Policies)</li>
          <li>Certificate of Employment</li>
        </ul>
      </div>

      <div class="bg-orange-50 border border-orange-100 rounded-lg p-4">
        <p>
          <strong>Important:</strong> Claims processing will begin only upon receipt of complete documentary requirements. Incomplete submissions may result in processing delays.
        </p>
      </div>

    </div>
  `,
      },
      {
        question: "Dental",
        answer: `
    <div class="space-y-4">

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Dental Availment Process
        </h4>

        <ol class="list-decimal pl-5 space-y-2">
          <li>
            Choose your preferred accredited dentist from the IWPCI directory.
          </li>
        </ol>

        <div class="ml-6 mt-2">
          <p class="font-medium mb-1">Options:</p>
          <ul class="list-disc pl-5 space-y-1">
            <li>Members may choose their preferred accredited dentist.</li>
            <li>Members may contact the IWPCI office for assistance in selecting a preferred dentist.</li>
          </ul>
        </div>

        <ol start="2" class="list-decimal pl-5 mt-3 space-y-2">
          <li>
            Schedule an appointment with your chosen dental clinic.
          </li>

          <li>
            Visit the dentist on your confirmed appointment date.
          </li>

          <li>
            Upon arrival at the dental clinic, present your
            <strong>IWC Wellness Card</strong> together with
            <strong>one (1) valid government-issued ID with photo</strong>.
          </li>

          <li>
            Complete the required member information after availing of the dental service.
          </li>
        </ol>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Important Reminders
        </h4>

        <ul class="list-disc pl-5 space-y-2">
          <li>
            Members must provide their employer's name, contact number, and signature after availing of dental benefits.
          </li>

          <li>
            Members should only sign beside or across the dental procedures that were actually rendered and performed by the dentist.
          </li>
        </ul>
      </div>

      <div class="bg-orange-50 border border-orange-100 rounded-lg p-4">
        <h4 class="font-semibold text-orange-500 mb-3">
          Need Assistance?
        </h4>

        <div class="space-y-1">
          <p><strong>Smart:</strong> 0908-8913655</p>
          <p><strong>Globe:</strong> 0917-8269156</p>
          <p><strong>Sun:</strong> 0933-8792346</p>
          <p>
            <strong>Facebook:</strong>
            IWC Wellness and Preventive Consultancy Inc.
          </p>
        </div>
      </div>

    </div>
  `,
      },
    ];
    const availmentProcessTagalog = [
      {
        question: "Out-Patient",
        answer: `
      <div class="space-y-4">

        <div>
          <h4 class="font-semibold text-orange-500 mb-2">
            Para sa mga Accredited na Ospital / Klinika
          </h4>

          <ul class="list-disc pl-5 space-y-2">
            <li>Pumunta sa OPD HMO o Industrial Department.</li>
            <li>Ipakita ang inyong IWC Membership Card at isang valid na government-issued ID para sa beripikasyon.</li>
            <li>Makikipag-ugnayan ang staff ng ospital o klinika sa IWC Customer Service Department upang kumpirmahin ang inyong eligibility at mga available na benepisyo.</li>
            <li>Kapag nakumpirma na ang inyong eligibility, ibibigay ang kinakailangang pag-apruba.</li>
            <li>Maari nang magpatuloy sa konsultasyon o kinakailangang serbisyong medikal.</li>
            <li>
              <strong>Ang anumang halagang lalampas sa aprubadong benepisyo ay sasagutin ng miyembro.</strong>
            </li>
          </ul>
        </div>

     

      </div>
    `,
      },
      {
        question: "In-Patient",
        answer: `
      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Proseso ng Pag-Avail para sa In-Patient
        </h4>

        <ul class="list-disc pl-5 space-y-2">
          <li>Pumunta sa HMO o Admitting Department ng accredited na ospital.</li>
          <li>Ipakita ang inyong IWC Membership Card at isang valid na government-issued ID para sa beripikasyon.</li>
          <li>Makikipag-ugnayan ang staff ng ospital sa IWC Customer Service Department upang kumpirmahin ang inyong eligibility at mga available na benepisyo.</li>
          <li>Kapag nakumpirma na ang inyong eligibility, ibibigay ang kaukulang <strong>Letter of Eligibility (LOE)</strong>.</li>
        </ul>
      </div>
    `,
      },
      {
        question: "Annual Physical Examination (APE)",
        answer: `
      <div class="space-y-4">

        <div>
          <h4 class="font-semibold text-orange-500 mb-2">
            Mga Alituntunin para sa Annual Physical Examination (APE)
          </h4>

          <ol class="list-decimal pl-5 space-y-3">
            <li>
              Ang lahat ng kahilingan para sa APE ay dapat iendorso ng Marketing Agent at ipagbigay-alam sa IWC Customer Service Department (CSD) bago ang availment.
            </li>

            <li>
              <strong>Pagsusumite ng Kahilingan para sa APE</strong>

              <p class="mt-2 mb-1">
                Ang kahilingan para sa APE ay dapat isumite bago ang nais na iskedyul:
              </p>

              <div class="ml-4">
                <p class="font-medium">Walk-in APE:</p>

                <ul class="list-disc pl-5 mt-1 space-y-1">
                  <li>2 araw para sa indibidwal (1–4 kalahok)</li>
                  <li>5 araw para sa maliit na grupo (5–10 kalahok)</li>
                  <li>2 linggo para sa malaking grupo (11 o higit pang kalahok)</li>
                </ul>

                <p class="font-medium mt-3">Mobile / On-Site APE:</p>

                <ul class="list-disc pl-5 mt-1">
                  <li>Dapat isumite ang kahilingan nang hindi bababa sa 3 linggo bago ang iskedyul.</li>
                </ul>
              </div>
            </li>

            <li>
              <strong>Pagdalo ng Miyembro</strong>

              <ul class="list-disc pl-5 mt-2 space-y-1">
                <li>Ang mga miyembrong nabigyan na ng pre-approval code ay inaasahang dadalo sa kanilang nakatakdang APE.</li>
                <li>Kung hindi makakadalo, kinakailangang ipaalam ito sa IWC nang hindi bababa sa 24 oras bago ang iskedyul.</li>
                <li>Ang hindi pagbibigay ng abiso ay magreresulta sa pag-tag sa miyembro bilang <strong>"Already Availed"</strong> at mawawala ang kanyang APE benefit para sa taong iyon.</li>
                <li>Maaaring sagutin ng Marketing Agent ang halaga ng APE kung nais pa rin itong ipagkaloob sa miyembro.</li>
              </ul>
            </li>

            <li>
              Ang Mobile / On-Site APE ay maaari lamang para sa mga grupong may <strong>100 o higit pang kalahok.</strong>
            </li>

            <li>
              Susuriin at ibeberipika ng IWC-CSD ang lahat ng naendorso na miyembro.
            </li>

            <li>
              Matapos ang beripikasyon, ang mga kwalipikadong miyembro lamang ang ieendorso sa klinika para sa APE availment.
            </li>
          </ol>
        </div>

      </div>
    `,
      },
      {
        question: "Insurance",
        answer: `
      <div class="space-y-4">

        <div>
          <h4 class="font-semibold text-orange-500 mb-2">
            Proseso ng Insurance Claim
          </h4>

          <ol class="list-decimal pl-5 space-y-2">
            <li>
              Ang claim ay dapat maisampa sa loob ng <strong>isang (1) taon</strong> mula sa petsa ng pagkamatay. Para sa late filing, kinakailangan ang <strong>Letter of Late Filing</strong>.
            </li>

            <li>
              Isumite ang orihinal na notarized na dokumento o mag-email ng scanned notarized copies sa:
              <div class="mt-2 ml-2">
                <p><strong>policy.department@iwc.com.ph</strong></p>
                <p><strong>iwc.policydepartment@gmail.com</strong></p>
              </div>
            </li>

            <li>
              Pagkatanggap ng mga dokumento, susuriin ito at ipapasa sa First Life Insurance para sa paunang ebalwasyon.
            </li>

            <li>
              Ipapaalam sa claimant kung kumpleto na ang mga dokumento o kung may mga karagdagang requirements na kinakailangan.
            </li>

            <li>
              Kapag naaprubahan, ang claimant na nagsumite lamang ng scanned copies ay kinakailangang magsumite ng lahat ng orihinal na notarized na dokumento.
            </li>

            <li>
              Ang processing time ay humigit-kumulang <strong>45 araw</strong> mula sa pagtanggap ng kumpletong requirements.
            </li>
          </ol>
        </div>

      </div>
    `,
      },
      {
        question: "Dental",
        answer: `
      <div class="space-y-4">

        <div>
          <h4 class="font-semibold text-orange-500 mb-2">
            Proseso ng Pag-Avail ng Dental Benefits
          </h4>

          <ol class="list-decimal pl-5 space-y-2">
            <li>Pumili ng inyong nais na accredited dentist mula sa IWPCI directory.</li>
            <li>Magpa-schedule ng appointment sa napiling dental clinic.</li>
            <li>Pumunta sa dental clinic sa nakatakdang petsa ng inyong appointment.</li>
            <li>
              Sa pagdating sa klinika, ipakita ang inyong
              <strong>IWC Wellness Card</strong> at
              <strong>isang valid na government-issued ID na may larawan.</strong>
            </li>
            <li>Kumpletuhin ang kinakailangang impormasyon pagkatapos ma-avail ang dental service.</li>
          </ol>
        </div>

        <div>
          <h4 class="font-semibold text-orange-500 mb-2">
            Mahahalagang Paalala
          </h4>

          <ul class="list-disc pl-5 space-y-2">
            <li>Kinakailangang ilagay ng miyembro ang pangalan ng employer, contact number, at lagda pagkatapos gamitin ang dental benefits.</li>
            <li>Tanging sa mga dental procedures na aktuwal na isinagawa ng dentista dapat pumirma ang miyembro.</li>
          </ul>
        </div>

      </div>
    `,
      },
    ];

    const toggleAccordion = (index) => {
      activeIndex.value = activeIndex.value === index ? null : index;
    };

    const availmentProcess = computed(() => {
      return selectedLanguage.value === "ph"
        ? availmentProcessTagalog
        : availmentProcessEnglish;
    });

    return {
      activeIndex,
      toggleAccordion,
      translations,
      selectedLanguage,
      availmentProcess,
    };
  },
};
</script>
